import * as yup from "yup";
export const addItemValidationSchema = yup
  .object({
    barcode: yup.string().trim().required(),
  })
  .required();
